<requirement045 :i18nWsKey="i18nWsKey" :workSupportId="workSupportId"></requirement045>